import { queryStringToParams } from 'Helpers/url';

export const urls = {
    getNotifications: '/api/notification-hub/messages',
    updateNotifications: '/api/notification-hub/messages'
};

export const initialState = {
    data: [],
    metadata: {},
    isFetching: false,
    isError: false
};

const transformGetData = data => {
    return {
        data: data.data,
        metadata: data.meta,
        isFetching: false,
        isError: false
    };
};

const transformAppendGetData = (data, state) => {
    const notifications = state.data ? state.data : [];
    const newData = [
        ...notifications,
        ...data.data
    ];

    return {
        data: newData,
        metadata: data.meta,
        isFetching: false,
        isError: false
    };
};

const transformRequestData = state => {
    const data = state.data ? state.data : [];
    const metadata = state.metadata ? state.metadata : {};

    return {
        data,
        metadata,
        isFetching: true,
        isError: false
    };
};

const transformPutData = (action, state) => {
    const data = state.data ? state.data : [];
    const metadata = state.metadata ? state.metadata : {};
    const params = queryStringToParams(action.params);
    const status = JSON.parse(params.status);

    for (const key in status) {
        const notification = data.find(notification => notification.messageId === key);

        if (notification) {
            notification.status = status[key];
        }
    }

    return {
        data,
        metadata,
        isFetching: false,
        isError: false
    };
};

const transformRequestPutData = state => {
    const data = state.data ? state.data : [];
    const metadata = state.metadata ? state.metadata : {};

    return {
        data,
        metadata,
        isFetching: false,
        isError: false
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RESPONSE_PUT_UPDATE_NOTIFICATIONS':
            return transformPutData(action, state);
        case 'REQUEST_UPDATE_NOTIFICATIONS':
            return transformRequestPutData(state);
        case 'RECEIVE_NOTIFICATIONS':
            return transformGetData(action.data);
        case 'RECEIVE_APPEND_NOTIFICATIONS':
            return transformAppendGetData(action.data, state);
        case 'REQUEST_NOTIFICATIONS':
        case 'REQUEST_APPEND_NOTIFICATIONS':
            return transformRequestData(state);
        default:
            return state;
    }
};
